import { Ace as AceNamespace } from 'ace-builds';
import { AceEditorTheme } from 'modules/aceEditor';
import { FC, PropsWithChildren, useRef } from 'react';
import { JsonEditorContext } from './JsonEditorContext';

type JsonEditorContextProviderProps = {
  aceEditorTheme?: AceEditorTheme;
};

export const JsonEditorContextProvider: FC<PropsWithChildren<JsonEditorContextProviderProps>> = ({
  children,
  aceEditorTheme = AceEditorTheme.Monokai,
}) => {
  const editor = useRef<AceNamespace.Editor | null>(null);

  const undo = () => {
    const thisEditor = editor.current;
    if (thisEditor) {
      thisEditor.undo();
      thisEditor.focus();
    }
  };

  const redo = () => {
    const thisEditor = editor.current;
    if (thisEditor) {
      thisEditor.redo();
      thisEditor.focus();
    }
  };

  return (
    <JsonEditorContext.Provider value={{ editor, aceEditorTheme, undo, redo }}>
      {children}
    </JsonEditorContext.Provider>
  );
};
